
@if (isNewsUpdateShow ) {
  <app-news-updates #test [mediaObject]="mediaObject"></app-news-updates>
}

<main class="content-wrapper" [ngStyle]="{ background: selectedMode === 'dark' ? '#111526' : '' }">
  <div class="container-fluid">
    <div class="col-12 pl-0">
      <div class="gallery-heading mb-4" [ngClass]="{ 'dark-text': selectedMode === 'dark' }">
        <h1> <span>Gallery</span></h1>
      </div>
    </div>
    <div class="gallery-bg px-3 py-4 mb-4" [ngClass]="{ 'dark-background': selectedMode === 'dark' }">
      <div class="row">
        @for (media of gallery; track media; let i = $index) {
          <div class="col-md-6 col-lg-4 col-xxl-3" (click)="openModal(media)">
            <div class="image-card mt-3">
              <img [src]="getImagePath() + '/' + media.path" style="width: 100%; object-fit: cover;" class="hover-shadow cursor">
              <div class="overlay">
                <i class="fa fa-arrows-alt" aria-hidden="true"></i>
              </div>
            </div>
          </div>
        }
      </div>
    </div>

    <!-- Modal -->
    <!-- <div class="modal fade gallery-view-modal" id="galleryModal" tabindex="-1" role="dialog" aria-labelledby="basicModal" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="gallery-modal-content">
          <img class="d-block w-100" [src]="getImagePath() + '/' + selectedMedia?.path" style="width: 100%;  object-fit: contain;" alt="selected image">

        </div>
        <div class="gallery-modal-header-inner mt-3">
          <div class="btn btn-danger" (click)="deleteImage(selectedMedia.id)">
            Delete
          </div>
        </div>

      </div>

      <div class="gallery-modal-header justify-content-center mt-4">
        <div class="gallery-modal-header-inner mr-3 pr-3 pl-3">
          <button (click)="deleteImage(selectedMedia.id)">
            <i class="fa fa-trash-o"></i>
          </button>
        </div>
        <div class="gallery-modal-header-inner">
          <button (click)="gotoGallery()">
            <img src="../../../../assets/images/gallery-icon-m.svg" alt="" >
          </button>
        </div>
        <div class="gallery-modal-header-inner ml-3 pl-3 pr-3">
          <button id="close" data-dismiss="modal" aria-label="Close" >
            <img src="../../../../assets/images/cross-icon.svg" alt="">
          </button>
        </div>

      </div>
    </div>
  </div> -->

</div>
</main>
